<template>
  <v-autocomplete
      :filled="!!filled"
      v-model="currentValue"
      :prepend-icon="$vuetify.breakpoint.smAndUp && icon !== false ? 'mdi-relation-many-to-many' : ''"
      :items="[...initialItems, ...items]"
      :loading="fetching || fetchingInitial"
      :disabled="fetchingInitial"
      :search-input.sync="searchInput"
      :placeholder="placeholder ? placeholder : $t('placeholder')"
      persistent-placeholder
      multiple
      chips
      clearable
      :menu-props="{ closeOnContentClick: !!closeOnContentClick }"
      small-chips
      deletable-chips
      hide-no-data
      hide-selected
      cache-items
      :label="label ? label : $t('label')"
      hide-details
      @keyup.enter.prevent="$emit('enter')"
  >
    <template v-slot:item="{ item }">
      {{ item.text }}
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'RelationSelect',
  props: ['value', 'filled', 'entities', 'closeOnContentClick', 'icon', 'label', 'placeholder'],
  data () {
    return {
      currentValue: this.value,
      fetchingInitial: false,
      fetching: false,
      initialItems: [],
      items: [],
      searchInput: ''
    }
  },
  watch: {
    currentValue () {
      this.$emit('update:value', this.currentValue)
    },
    value (value) {
      this.currentValue = value
    },
    async searchInput (search) {
      await this.search(search)
    }
  },
  methods: {
    entitiesToItems (entities) {
      const items = []

      if (entities.monitors) {
        items.push(...entities.monitors.map(monitor => {
          return {
            text: this.$t('keyword:') + ' ' + monitor.keyword.term + ' (' + monitor.website.domain + ')',
            value: 'monitors:' + monitor.id
          }
        }))
      }
      if (entities.websites) {
        items.push(...entities.websites.map(website => {
          return {
            text: this.$t('website:') + ' ' + website.domain,
            value: 'websites:' + website.id
          }
        }))
      }
      if (entities.tags) {
        items.push(...entities.tags.map(tag => {
          return {
            text: this.$t('tag:') + ' ' + tag.name,
            value: 'tags:' + tag.id
          }
        }))
      }
      if (entities.notes) {
        items.push(...entities.notes.map(note => {
          return {
            text: this.$t('note:') + ' ' + note.description,
            value: 'notes:' + note.id
          }
        }))
      }

      return items
    },
    search: debounce(async function (query = '') {
      this.fetching = true

      try {
        const entities = (await this.$api.post('search', {
          query,
          on: this.entities,
          scopes: {
            'websites.has': ['monitors'],
            'tags.has': ['monitors'],
          },
          with: ['monitors.keyword', 'monitors.website']
        })).data

        this.items = this.entitiesToItems(entities)
      } finally {
        this.fetching = false
      }
    }, 250),
    async find (targets) {
      this.fetchingInitial = true

      try {
        const entities = (await this.$api.post('search', {
          targets,
          with: ['monitors.keyword', 'monitors.website']
        })).data

        this.initialItems = this.entitiesToItems(entities)
      } finally {
        this.fetchingInitial = false
      }
    }
  },
  async mounted () {
    if (this.value.length) {
      await this.find(this.value)
    }
    await this.search()
  }
}
</script>

<i18n>
{
	"en": {
		"keyword:": "Keyword :",
		"label": "Link to",
		"note:": "NOTE : ",
		"placeholder": "All the elements",
		"tag:": "Tags:",
		"website:": "Website :"
	},
	"es": {
		"keyword:": "Palabra clave :",
		"label": "Enlace a",
		"note:": "NOTA :",
		"placeholder": "Todos los elementos",
		"tag:": "Etiquetas:",
		"website:": "Sitio web :"
	},
	"fr": {
		"keyword:": "Mot clé :",
		"label": "Lier à",
		"note:": "Note :",
		"placeholder": "Tous les éléments",
		"tag:": "Tag :",
		"website:": "Site web :"
	},
	"it": {
		"keyword:": "Parola chiave :",
		"label": "Collega a",
		"note:": "NOTA :",
		"placeholder": "Tutti gli elementi",
		"tag:": "Tag:",
		"website:": "Sito web :"
	},
	"pt": {
		"keyword:": "Palavra-chave :",
		"label": "Ligar a",
		"note:": "NOTA :",
		"placeholder": "Todos os elementos",
		"tag:": "Tag :",
		"website:": "Site :"
	},
	"pl": {
		"keyword:": "Słowo kluczowe :",
		"label": "Połącz z",
		"note:": "UWAGA :",
		"placeholder": "Wszystkie elementy",
		"tag:": "Tagi:",
		"website:": "Strona internetowa :"
	}
}
</i18n>